<app-table-documents
  *ngIf="contact$ | async as contact"
  [source$]="documents$"
  (add)="onAdd($event, contact)"
  (delete)="onDelete($event, contact)"
></app-table-documents>
